import { StatusTag } from "../../../components/chips/status-tag";
import { CONST_PAYMENT_STATUS_LIST } from "../../../constants/lists";
import { getPaymentStatus } from "../../../services/utils";

function PaymentStatus({ data }) {
  const status = getPaymentStatus(data);
  const statusConfig = CONST_PAYMENT_STATUS_LIST[status];

  if (!statusConfig?.label) return null;

  const { fontColor, bgColor } = statusConfig;

  return (
    <StatusTag
      text={statusConfig.label}
      fontColor={fontColor}
      bgColor={bgColor}
    />
  );
}

export { PaymentStatus };
